import { IconButton, IconButtonSize, IconButtonTheme } from '@apply/components';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

interface DownloadFileButtonProps {
    id: string;
    /** The file's download link; nothing is shown without one (a file that hasn't been saved yet). */
    url: string | undefined;
}

/** Downloads a saved file. */
export const DownloadFileButton = ({ id, url }: DownloadFileButtonProps) => {
    if (!url) {
        return null;
    }

    return (
        <IconButton
            id={id}
            theme={IconButtonTheme.Transparent}
            size={IconButtonSize.ExtraSmall}
            icon={faDownload}
            hint='Download File'
            handleClick={() => (window.location.href = url)}
        />
    );
};
